module.exports = __webpack_public_path__ + "img/9.4ae6f098.png";